import { useUIStore } from '../../stores/ui/ui.store';
import Toast from './Toast';

const NotificationsArea = () => {
  const { notification, hideToast } = useUIStore((state) => state);
  const closeHandler = () => hideToast();

  return (
    <Toast
      severity={notification.severity}
      open={notification.show}
      message={notification.message}
      onClose={closeHandler}
    />
  );
};

export default NotificationsArea;
